<template>
    <div class="modal-overlay" @click="props.close()">
    <div class="modal-content" @click.stop>
        <div class="modal-title">{{props.text}}</div>
            <slot />
        <button class="modal-close"  @click="uioknoClose()">{{props.button}}</button>
    </div>
    </div>
</template>

<script setup>
const props = defineProps({
  close: {
    type: Function,
    default: () => {} // пустая функция
  },
  text: {
    type: String,
    default: 'Закрыть'
  },
  button: {
    type: String,
    default: 'Готово'
  },
  func: {
    type: Function,
    default: null
  }
})

const uioknoClose = () => { 

  if(props.func == null){
    return props.close() 
  }
  return props.func()
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--overlay-light);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    z-index: 1000000;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity var(--transition-fast), visibility var(--transition-fast);
}

.modal-overlay.active {
    opacity: 1;
    visibility: visible;
}

.modal-content {
    background-color: var(--bg-primary);
    border-radius: 32px;
    width: 94%;
    padding: 28px 24px;
    box-shadow: 0 20px 40px var(--shadow-color);
    transform: scale(0.95);
    transition: transform var(--transition-fast);
    text-align: center;
    border: 1px solid var(--border-light);
        overflow: scroll;
    max-height: 90vh;
}

.modal-overlay.active .modal-content {
    transform: scale(1);
}

.modal-title {
       font-weight: 500;
    margin-bottom: 20px;
    letter-spacing: -0.3px;
    color: var(--text-primary);
    font-size: 18px;
    border-bottom: 1px solid var(--header-border);
    padding-bottom: 10px;
}


.modal-close {
   background-color: var(--btn-accent-bg);
    color: var(--btn-accent-text);
    border: none;
    padding: 14px 30px;
    border-radius: 40px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    width: 100%;
    transition: background-color var(--transition-fast);
    margin-top: 10px;
    border: 1px solid var(--btn-accent-bg);
}

.modal-close:hover {
    background-color: var(--btn-accent-hover);
    border-color: var(--btn-accent-hover);
}

.modal-close:active {
    transform: scale(0.97);
}


html.dark .modal-content {
    border-color: var(--border-medium);
}

html.dark .stock-list {
    border-color: var(--border-medium);
}
</style>
